import { createReducer } from 'redux-act'
import * as app from './app'
import { message, notification } from 'antd'

export const REDUCER = 'login'

export const submit = ({ username, password }: { username: string, password: string }) => (
  dispatch: Function,
  getState: Function,
) => {
  return new Promise((resolve, reject) => {
    dispatch(app.addSubmitForm(REDUCER))
    app
      .login(username, password, dispatch)
      .then(result => {
        dispatch(app.deleteSubmitForm(REDUCER))

        resolve(result)
      })
      .catch(err => {
        dispatch(app.deleteSubmitForm(REDUCER))
        reject(err)
      })
  })
}

const initialState = {}
export default createReducer({}, initialState)



// WEBPACK FOOTER //
// ./src/ducks/login.js